<template lang="pug">
  .sort-modal.open(v-if="sorting" v-click-outside="cancel")
    .sort-modal-inner
      ul.sortable
        draggable(
          v-model="columns"
          :options="{handle: '.sortable-handle'}"
          @end="onEnd"
        )
          li.sortable-item(v-for="column in columns" :key="column.key")
            label.checkbox
              input(type="checkbox", :value="column.key", v-model="displayedColumns")
              span {{ column.label }}
            .sortable-handle
    p.buttons
      input.button-main(type="button" value="表示変更", @click.prevent="configure")
      a(@click="cancel") キャンセル
</template>

<script>
  import draggable from 'vuedraggable'
  import ClickOutside from 'vue-click-outside'
  import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'

  export default {
    directives: { ClickOutside },
    components: {
      draggable,
    },
    created () {
      this.initialize()
    },
    watch: {
      $route () {
        this.done()
      },
      sorting (v) {
        !v && this.initialize()
      },
    },
    mounted () {
      this.popupItem = this.$el
    },
    computed: {
      ...mapGetters('common', ['spMode']),
      ...mapState({
        configuredColumns: state => state.corporationTableConfiguration.columns,
        configuredDisplayedColumns: state => state.corporationTableConfiguration.displayedColumns,
        sorting: state => state.corporationTableConfiguration.sorting,
        user: state => state.user.detail,
      }),
    },
    data () {
      return {
        columns: [],
        displayedColumns: [],
      }
    },
    methods: {
      ...mapMutations({
        done: 'corporationTableConfiguration/done',
      }),
      ...mapActions({
        submitConfiguration: 'corporationTableConfiguration/configure',
        initializeConfiguration: 'corporationTableConfiguration/initialize',
      }),
      onEnd () {
        const { columns, displayedColumns } = this
        this.displayedColumns = columns.filter(c => displayedColumns.indexOf(c.key) >= 0)
                                       .map(c => c.key)
      },
      initialize () {
        if (this.configuredColumns.length === 0) {
          this.initializeConfiguration({
            displayedColumns: this.user.corporation_displayed_columns,
            spMode: this.spMode,
          })
        }
        this.columns = this.configuredColumns.concat()
        this.displayedColumns = this.configuredDisplayedColumns.concat()
      },
      cancel () {
        this.initialize()
        this.done()
      },
      configure () {
        const { columns, displayedColumns } = this
        this.submitConfiguration({ columns, displayedColumns })
        this.done()
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/CorporationColumnSortModal.vue